import { render } from "./ServiceModal.vue?vue&type=template&id=5ae94339&scoped=true"
import script from "./ServiceModal.vue?vue&type=script&lang=js"
export * from "./ServiceModal.vue?vue&type=script&lang=js"

import "./ServiceModal.vue?vue&type=style&index=0&id=5ae94339&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae94339"]])

export default __exports__